import BottegaProvider from '@components/BottegaProvider'
import NearestBottega from '@components/NearestBottega'
import BottegaList from './BottegaList'
import Form from './Form'
import IconList from './IconList'
import Slider from './Slider'
import TopSection from './TopSection'

export const BottegasPage = () => {
  return (
    <BottegaProvider>
      <Form />
      <NearestBottega />
      <TopSection />
      <Slider />
      <IconList id="bottega-top" />
      <BottegaList />
    </BottegaProvider>
  )
}
